import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ManageModal = ({
  username,
  isAdmin,
  onChange,
  onSubmit,
  show,
  onHide,
  toggleIsAdmin
}) => {
  return (
    <form onSubmit={onSubmit}>
      <Modal isOpen={show} toggle={onHide}>
        <ModalHeader toggle={onHide}>Manage User</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={onChange}
              autoFocus
            />
          </div>
          <div className="form-check">
            <label htmlFor="isAdmin" className="form-check-label">
              <input
                type="checkbox"
                name="isAdmin"
                id="isAdmin"
                className="form-check-input"
                onChange={toggleIsAdmin}
                checked={isAdmin}
              />
              Is Admin
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={onHide}>
            <i className="fa fa-times-circle" /> Cancel
          </button>

          <button type="submit" className="btn btn-success" onClick={onSubmit}>
            <i className="fa fa-check-circle" /> Save
          </button>
        </ModalFooter>
      </Modal>
    </form>
  );
};

export default ManageModal;



// WEBPACK FOOTER //
// ./src/pages/Users/ManageModal.jsx